import React from 'react';
import ReactDOM from 'react-dom/client';

// Used Components
import App from './App';

// Style Shared File
import "../src/styleFiles/index.css"

// Libraires Importing [ Bootstrap, Fontawsome ]
import "../node_modules/bootstrap/dist/css/bootstrap.css"
import "../node_modules/bootstrap/dist/js/bootstrap.js"
import "../node_modules/@fortawesome/fontawesome-free/css/all.css"

// Routing
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

